import { Route } from '@angular/router';
import { MainLayoutComponent } from './layout/app-layout/main-layout/main-layout.component';
import { AuthGuard } from '@core/guard/auth.guard';
import { AuthLayoutComponent } from './layout/app-layout/auth-layout/auth-layout.component';
import { Page404Component } from './authentication/page404/page404.component';
import { UserRole } from '@core';
import { KeycloakRoles } from '@core/auth/keycloak.config';
import { RoleRedirectComponent } from '@core/components/role-redirect/role-redirect.component';

export const APP_ROUTE: Route[] = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { 
        path: '', 
        component: RoleRedirectComponent,
        pathMatch: 'full' 
      },
      {
        path: 'master',
        canActivate: [AuthGuard],
        data: {
          role: [UserRole.SuperAdmin],
          roles: [KeycloakRoles.SUPER_ADMIN],
        },
        loadChildren: () =>
          import('./master/master.routes').then((m) => m.MASTER_ROUTE),
      },
      {
        path: 'admin',
        canActivate: [AuthGuard],
        data: {
          role: [UserRole.SuperAdmin, UserRole.PartnerAdmin, UserRole.CompanyAdmin],
          roles: [KeycloakRoles.SUPER_ADMIN, KeycloakRoles.PARTNER_ADMIN, KeycloakRoles.COMPANY_ADMIN],
        },
        loadChildren: () =>
          import('./admin/admin.routes').then((m) => m.ADMIN_ROUTE),
      },
      {
        path: 'enterprise',
        canActivate: [AuthGuard],
        data: {
          role: [UserRole.SuperAdmin, UserRole.PartnerAdmin, UserRole.CompanyAdmin, UserRole.EnterpriseAdmin, UserRole.EnterpriseAnalyst],
          roles: [KeycloakRoles.SUPER_ADMIN, KeycloakRoles.PARTNER_ADMIN, KeycloakRoles.COMPANY_ADMIN, KeycloakRoles.ENTERPRISE_ADMIN, KeycloakRoles.ENTERPRISE_ANALYST],
        },
        loadChildren: () =>
          import('./enterprise/enterprise.routes').then((m) => m.ENTERPRISE_ROUTE),
      },
      {
        path: 'company',
        canActivate: [AuthGuard],
        data: {
          role: [UserRole.SuperAdmin, UserRole.PartnerAdmin, UserRole.CompanyAdmin],
          roles: [KeycloakRoles.SUPER_ADMIN, KeycloakRoles.PARTNER_ADMIN, KeycloakRoles.COMPANY_ADMIN],
        },
        loadChildren: () =>
          import('./company/company.routes').then((m) => m.COMPANY_ROUTE),
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('./profile/profile.routes').then((m) => m.PROFILE_ROUTE),
      },
      {
        path: 'about',
        loadChildren: () =>
          import('./about/about.routes').then((m) => m.ABOUT_ROUTE),
      },
      {
        path: 'shared/operations/imports',
        canActivate: [AuthGuard],
        data: {
          role: [UserRole.SuperAdmin, UserRole.PartnerAdmin, UserRole.CompanyAdmin, UserRole.EnterpriseAdmin, UserRole.EnterpriseAnalyst],
          roles: [KeycloakRoles.SUPER_ADMIN, KeycloakRoles.PARTNER_ADMIN, KeycloakRoles.COMPANY_ADMIN, KeycloakRoles.ENTERPRISE_ADMIN, KeycloakRoles.ENTERPRISE_ANALYST],
        },
        loadChildren: () =>
          import('./shared/operations/imports/imports.routes').then((m) => m.IMPORTS_ROUTES),
      },
    ],
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./authentication/page403/page403.component').then((m) => m.Page403Component),
  },
  {
    path: 'authentication',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./authentication/auth.routes').then((m) => m.AUTH_ROUTE),
  },
  { path: '**', component: Page404Component },
];
